// react
import React from 'react';

// mui
import { Box, Stack, Typography } from '@mui/material';

export interface AdminTablePageProps {
  /** Page title */
  title: string;
  /** Optional description below the title */
  description?: string;
  /** The table/content to render */
  children: React.ReactNode;
}

/**
 * AdminTablePage is a full-width page template for admin table pages.
 * It provides minimal horizontal padding so tables can use maximum screen real estate.
 */
export const AdminTablePage = ({
  title,
  description,
  children,
}: AdminTablePageProps) => {
  return (
    <Stack
      sx={{ minHeight: '100%', py: { xs: 2, sm: 3 }, px: { xs: 2, sm: 3 } }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant='h5'>{title}</Typography>
        {description && (
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              mt: 0.5,
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
      {children}
    </Stack>
  );
};

AdminTablePage.displayName = 'AdminTablePage';
export default AdminTablePage;
